import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/voice/VoiceHubClient.tsx");
